
import { Link, useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { useLoginAdminMutation } from "slices/authApi";
import { setAuth } from "slices/authSlice";
import { CircularProgress } from "@mui/material";
import logo from 'assets/images/logo.svg';
import Swal from "sweetalert2";
function Basic() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [loginAdmin, { isLoading: verifyLoading }] = useLoginAdminMutation();

  const handleSignIn = async (data) => {
    try {
      const body = { email: data.email, password: data.password };
      const response = await loginAdmin(body).unwrap();
      if (response.token) {
        dispatch(setAuth(response))
        if (response?.user?.role === "staff") {
          navigate("/profile");
        } else {
          navigate("/dashboard/overview");

        }
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Login Failed",
        text: error?.data?.message || "Invalid email or password. Please try again.",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK",
      });
    }
  }

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            <img src={logo} class="m-view" style={{ width: "100%" }} alt={"logo"} />
          </MDTypography>
          <Grid
            container
            spacing={3}
            justifyContent="center"
            sx={{ mt: 1, mb: 2 }}
          >
          </Grid>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleSubmit(handleSignIn)}>
            <MDBox mb={2}>
              <MDInput
                type="text"
                label="Email"
                fullWidth
                {...register("email", { required: true })}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput type="password" label="Password" fullWidth {...register("password")} />
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton
                variant="gradient"
                color="info"
                type={"submit"}
                fullWidth
                disabled={verifyLoading}
              >
                {verifyLoading ? <CircularProgress color="inherit" size={"20px"} /> : "sign in"}
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
